import React, { FC } from 'react';
import { EnterpriseCardType } from './enterpriseCard.types';
import { EnterpriseCardTitle } from './EnterpriseCardTitle';
import { Spacing } from '../../components/entities-card/Spacing';
import { EnterpriseDetails } from './EnterpriseDetails';
import { EntepriseFollowButton } from '../follow-button/EntepriseFollowButton';

type Props = {
  enterprise: EnterpriseCardType;
  href: string | undefined;
  onClick: () => void;
};

export const EnterpriseCardProfile: FC<Props> = ({ enterprise, ...rest }) => {
  return (
    <>
      <EnterpriseCardTitle {...rest}>
        {enterprise.raisonSociale}
      </EnterpriseCardTitle>
      <Spacing />
      <EnterpriseDetails enterprise={enterprise} />
      <Spacing />
      <EntepriseFollowButton
        raisonSociale={enterprise.raisonSociale}
        enterpriseId={enterprise.enterpriseId}
      />
    </>
  );
};
